module.exports = __webpack_public_path__ + "img/info-header.512adb35.svg";